import createInlineButtons from './inline-buttons.js';
import createInsertButtons from './insert-buttons.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-editor-common';
import '../modals.js';
import './buttonInputModal.js';
import 'prop-types';
import 'react';
import 'lodash';
import 'react-custom-scrollbars';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import '../components/design-component.js';
import '../components/color-toggle-component.js';
import 'classnames';
import '../style-inject.es-746bb8ed.js';
import '../constants.js';
import 'ricos-schema';
import '../types.js';
import '../defaults.js';
import '../components/settings-component.js';
import '../components/preview-component.js';
import '../button-component.js';
import '../classNameStrategies.js';
import '../default-styles-888649ac.js';
import '../components/button-viewer.js';
import '../viewer/button-viewer.js';
import 'ricos-context';
import '../icons/InsertPluginIcon.js';

const createToolbar = ({
  settings,
  t,
  isMobile,
  customTooltip,
  relValue,
  anchorTarget,
  type
}) => {
  return {
    InlineButtons: createInlineButtons({ settings, isMobile, relValue, anchorTarget, type }),
    InsertButtons: createInsertButtons({ t, settings, customTooltip, relValue, anchorTarget }),
    name: "button"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
